import { useState, useEffect } from 'react';
import { Loader } from 'lucide-react';

import { t, type PlainKey } from '../i18n/t';

const loadingMessages: PlainKey[] = ['loading-analyzing', 'loading-insights', 'loading-reviewing'];

export function LoadingState() {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % loadingMessages.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="flex items-center gap-3 mb-4">
        <Loader className="w-16 h-16 text-primary animate-spin" />
        <span className="text-lg font-medium text-base-content animate-pulse">{t(loadingMessages[messageIndex]!)}</span>
      </div>
    </div>
  );
}
